
import Axios from 'axios';
import { SERVER_URL } from 'Constants';
import { IUserResult } from 'Models/Store';

export type validate2faCodeArgs = {
	token: string,
	method: string,
	rememberMe?: boolean,
	rememberTwoFactor?: boolean,
}

type validate2faBody = {
	token: string,
	method: string,
	rememberMe?: boolean,
	rememberTwoFactor?: boolean,
};

export function validate2faCode({
	token,
	method,
	rememberMe,
	rememberTwoFactor,
}: validate2faCodeArgs) {
	const body: validate2faBody = { token, method };

	if (rememberMe !== undefined) body.rememberMe = rememberMe;
	if (rememberTwoFactor !== undefined) body.rememberTwoFactor = rememberTwoFactor;

	return Axios.post(`${SERVER_URL}/api/authorization/validate-2fa`, body);
}
// % protected region % [Customise validate2faCode here] end

// % protected region % [Customise TwoFactorLoginResponse here] off begin
export type TwoFactorLoginResponse = {
	type: '2fa-required',
	method: string,
	data: unknown,
}

type LoginBody = {
	username: string,
	password: string,
	rememberMe?: boolean,
};

export type LoginResponse = IUserResult | TwoFactorLoginResponse

export function login(username: string, password: string, rememberMe?: boolean): Promise<LoginResponse> {
	const postData: LoginBody = {
		username: username,
		password: password,
	};

	if (rememberMe !== undefined) {
		postData.rememberMe = rememberMe;
	}

	return Axios.post<LoginResponse>(`${SERVER_URL}/api/authorization/login`, postData)
		.then(x => x.data);
}


